import React, { useState, useMemo } from "react";
import { formatCurrency } from "../../../utils/numberUtils";
import PageContainer from "../../../components/geral/PageContainer";
import PageHeader from "../../../components/geral/PageHeader";
import PageContent from "../../../components/geral/PageContent";
import PageFooter from "../../../components/geral/PageFooter";
import Input from "../../../components/input/Input";
import "./ConsultaProdutoPage.css";
import { useProduto } from "../../../contexts/produtos/ProdutoContext";

// 🔤 Normaliza o texto: remove acentos, cedilha, pontuação e ignora maiúsculas
const normalizeText = (text) => {
  return text
    ? text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/ç/g, "c")
        .replace(/[^a-zA-Z0-9\s]/g, "")
        .toLowerCase()
        .trim()
    : "";
};

const ConsultaProdutoPage = () => {
  const { produtos } = useProduto();
  const [descricao, setDescricao] = useState("");

  // 🔍 Filtra conforme o usuário digita
  const produtosFiltrados = useMemo(() => {
    const termo = normalizeText(descricao);
    if (termo === "") return produtos;
    return produtos.filter((p) =>
      normalizeText(p.descricao || "").includes(termo)
    );
  }, [produtos, descricao]);

  return (
    <PageContainer>
      <h2 className="page-title">Consulta de Produtos</h2>

      <PageHeader>
        <Input
          label="Descrição do Produto"
          placeholder="Digite parte da descrição..."
          value={descricao}
          onChange={(e) => setDescricao(e.target.value)}
          size={220}
        />
      </PageHeader>

      <PageContent>
        <table className="page-content-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descrição</th>
              <th style={{ textAlign: "right", minWidth: "85px" }}>Valor Un</th>
              <th style={{ textAlign: "right", minWidth: "85px" }}>Custo Ult.</th>
              <th style={{ textAlign: "right", minWidth: "85px" }}>Custo Méd</th>
              <th>Grupo</th>
            </tr>
          </thead>
          <tbody>
            {produtosFiltrados.length > 0 ? (
              produtosFiltrados.map((produto) => (
                <tr key={produto.id}>
                  <td>{produto.id}</td>
                  <td>{produto.descricao}</td>
                  <td style={{ textAlign: "right", minWidth: "85px" }}>
                    {formatCurrency(produto.preco)}
                  </td>
                  <td style={{ textAlign: "right", minWidth: "85px" }}>
                    {formatCurrency(produto.custoUltimo)}
                  </td>
                  <td style={{ textAlign: "right", minWidth: "85px" }}>
                    {formatCurrency(produto.custoMedio)}
                  </td>
                  <td>{produto.grupo?.descricao || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">Nenhum produto encontrado.</td>
              </tr>
            )}
          </tbody>
        </table>
      </PageContent>

      <PageFooter>
        <div className="totais-footer">
          <strong>Total de Produtos:</strong> {produtosFiltrados.length}
        </div>
      </PageFooter>
    </PageContainer>
  );
};

export default ConsultaProdutoPage;